import React, { useEffect } from 'react';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormControl from '../shared/inputs/FormControl';
import ListView from '../shared/lists/ListView';
import MonthlyAdvertisingItem from './MonthlyAdvertisingItem';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import ExportButton from '../shared/buttons/ExportButton';

const MonthlyAdvertising = ({
    items,
    filter,
    pageInfo,
    setFilter,
    setUrl
}) => {
    const postUrl = `/api/reports/monthlyadvertising`;

    useEffect(() => setUrl(postUrl), []);

    const tableHead = (
        <thead>
            <tr>
                <SortableTh
                    content="Lead Source"
                    sort={pageInfo}
                    sortName="LeadSource"
                />
                <SortableTh
                    content="Sub Source"
                    sort={pageInfo}
                    sortName="SubLeadSource"
                />
                <SortableTh
                    content="Lead Count"
                    sort={pageInfo}
                    sortName="LeadsReceived"
                />
                <SortableTh
                    content="Appointments"
                    sort={pageInfo}
                    sortName="AppointmentsScheduled"
                />
                <SortableTh
                    content="Installs"
                    sort={pageInfo}
                    sortName="InstalledJobs"
                />
                <SortableTh
                    content="Appt. Conversion"
                    sort={pageInfo}
                    sortName="AppointmentConversion"
                />
                <SortableTh
                    content="Amount Spent"
                    sort={pageInfo}
                    sortName="AmountSpent"
                />
                <SortableTh
                    content="Cost Per Lead"
                    sort={pageInfo}
                    sortName="CostPerLead"
                />
                <SortableTh
                    content="Closing Rate"
                    sort={pageInfo}
                    sortName="ClosingRate"
                />
                <SortableTh
                    content="Installed Sales"
                    sort={pageInfo}
                    sortName="InstalledSales"
                />
                <SortableTh
                    content="Avg Sales"
                    sort={pageInfo}
                    sortName="AverageSale"
                />
                <SortableTh
                    content="Revenue Per Lead"
                    sort={pageInfo}
                    sortName="RevenuePerLead"
                />
                <SortableTh
                    content="Investment Return"
                    sort={pageInfo}
                    sortName="InvestmentReturn"
                />
                <th className="button-cell" style={{ width: "40px" }}>
                    <ExportButton
                        disabled={items === undefined || items === null || items.length === 0}
                        filter={filter}
                        url="/api/export/monthlyadvertising"
                    />
                </th>
            </tr>
        </thead>
    );

    const listItems = items.map((item, index) =>
        <MonthlyAdvertisingItem
            key={item.id}
            item={item}
        />
    );

    return (
        <Row>
            <Col>
                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label className="col-form-label-sm">
                            From
                        </Form.Label>
                        <FormControl className="form-control-sm"
                            defaultValue={filter.dateFrom}
                            name="dateFrom"
                            onChange={setFilter}
                            type="date"
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label className="col-form-label-sm">
                            To
                        </Form.Label>
                        <FormControl className="form-control-sm"
                            defaultValue={filter.dateTo}
                            name="dateTo"
                            onChange={setFilter}
                            type="date"
                        />
                    </Form.Group>
                    <Form.Group as={Col}>
                        <div className="d-flex" style={{ paddingTop: '26px' }}>
                            <label className="custom-control custom-checkbox d-inline-flex">
                                <input
                                    checked={filter.activeOnly || false}
                                    className="custom-control-input"
                                    name="activeOnly"
                                    onChange={setFilter}
                                    type="checkbox"
                                />
                                <span className="custom-control-label">&nbsp;</span>
                            </label>
                            <label style={{ marginLeft: '-5px' }}>
                                Only categories with activity
                                </label>
                        </div>
                    </Form.Group>
                </Form.Row>
                <Row className='pb-5 mt-3'>
                    <Col className="small">
                        <ListView
                            animate={false}
                            canAdd={false}
                            items={listItems}
                            tableHead={tableHead}
                        />
                        <PagedListControl
                            {...pageInfo}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default MonthlyAdvertising;